import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const attempts = ["Intentar 'hacerte notar' hablando más fuerte o riendo de más, lo que solo proyecta una energía de desesperación que ellos huelen a kilómetros.", "Mantener una 'postura de poder' rígida que aprendiste en seminarios de liderazgo, la cual levanta un muro de hielo entre tú y cualquier conexión emocional.", 'Forzar sonrisas constantes que no llegan a tus ojos, comunicando inconscientemente que eres poco confiable o que estás nerviosa.', 'Esperar que tu currículum o tus logros hablen por ti en una cita, cuando la atracción biológica ocurre mucho antes de que abras la boca.'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function FailedAttempts() {
  return <section className="py-24 px-6 bg-darker" data-id="element-19">
      <div className="max-w-4xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-21">
          <h2 className="font-serif text-3xl md:text-4xl text-cream mb-4" data-id="element-22">
            Lo Que Has Intentado <br className="md:hidden" data-id="element-23" />
            <span className="text-wine italic" data-id="element-24">(Y Por Qué No Funciona)</span>
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid gap-6" data-id="element-25">
          {attempts.map((attempt, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-4 bg-dark p-6 md:p-8 rounded-sm border border-wine/20" data-id="element-26">
              <div className="mt-1 flex-shrink-0 bg-wine/10 p-2 rounded-full" data-id="element-27">
                <X className="w-5 h-5 text-wine" data-id="element-28" />
              </div>
              <p className="font-sans text-cream/80 font-light leading-relaxed" data-id="element-29">
                {attempt}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}